import { Pipe, PipeTransform } from '@angular/core';
import { FlowDirection } from '../../../../data/src/lib/entities/treasury.model';

const LABELS: Record<FlowDirection, string> = {
  [FlowDirection.In]: 'Entrada',
  [FlowDirection.Out]: 'Saída',
};

@Pipe({ name: 'flowDirectionLabel', standalone: true, pure: true })
export class FlowDirectionLabelPipe implements PipeTransform {
  transform(value: FlowDirection): string {
    return LABELS[value];
  }
}
